import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import { FileAudio } from "lucide-react";
import CreatorShell from "@/components/creator/CreatorShell";
import ExportSongPicker from "@/components/exportaudio/ExportSongPicker";
import ExportBuilder from "@/components/exportaudio/ExportBuilder";
import ExportPacks from "@/components/exportaudio/ExportPacks";

function Hint() {
  return (
    <section data-testid="export-audio-hint" className="rounded-3xl border border-white/[0.08] bg-[#0a0d1c]/70 p-6 sm:p-8">
      <span className="grid h-12 w-12 place-items-center rounded-2xl bg-gradient-to-br from-sky-400 to-indigo-500 text-white"><FileAudio className="h-5 w-5" /></span>
      <h2 className="mt-5 font-display text-base font-semibold md:text-lg">Pick a song to export</h2>
      <ul className="mt-3 space-y-2 text-[13px] leading-relaxed text-white/60">
        <li>· Full mix as a 24-bit 48 kHz WAV and a 320 kbps MP3 — the song as it is, or any Mix Desk mix.</li>
        <li>· Stems as Lead vocal · Background vocals · Instrumental, or every part on its own.</li>
        <li>· Every WAV is exactly the same length and starts at 0:00, so it drops straight into Studio One.</li>
      </ul>
    </section>
  );
}

/** `/create/export-audio` — choose a song, what goes in the pack, then download the zip or any single file. */
export default function ExportAudioPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const songId = new URLSearchParams(location.search).get("song");
  const [tick, setTick] = useState(0);
  const pick = (id) => navigate(`/create/export-audio?song=${id}`, { replace: true });
  return (
    <CreatorShell testId="export-audio-page" back="/create" title="Export Audio" subtitle="Full mix and stems as 24-bit 48 kHz WAV + MP3 — every file lined up at 0:00, ready for Studio One.">
      <div className="grid items-start gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.35fr)]">
        <ExportSongPicker selected={songId} onPick={pick} />
        <div className="min-w-0 space-y-6">
          {songId ? <ExportBuilder key={songId} songId={songId} onStarted={() => setTick((t) => t + 1)} /> : <Hint />}
          <ExportPacks songId={songId} tick={tick} />
        </div>
      </div>
    </CreatorShell>
  );
}
